import React from "react";

interface EnforcedMFASetupFooterProps {
  afterSetupLocation: string;
}

export default class EnforcedMFASetupFooter extends React.Component<EnforcedMFASetupFooterProps> {
  render(): JSX.Element {
    return (
      <div className="form-panel__footer">
        <div className="h-stack is-right">
          <a className="button is-primary" href={this.props.afterSetupLocation}>
            Got it!
          </a>
        </div>
      </div>
    );
  }
}
